import React, { useEffect } from 'react';
import { Control, Controller } from 'react-hook-form';
import Box from '@material-ui/core/Box';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import { REALIZATION_DATE } from '../../../common/constants';
import { StoreBasicDataApiStructure } from 'common/types';
import { CheckoutType } from 'api/repositories/Checkout';
import { CheckoutValues } from 'store/ducks/checkout/types';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import ErrorPanel from 'common/components/ErrorPanel';
import { formatDateToPolish } from 'common/functions';

type Props = {
    cartToken: string;
    checkoutData: StoreBasicDataApiStructure<CheckoutType>;
    checkoutValues: CheckoutValues;
    control: Control;
    errors: any;
    fetchCheckoutData: Function;
};

const RealizationDate: React.FC<Props> = ({
    cartToken,
    checkoutData,
    checkoutValues,
    control,
    errors,
    fetchCheckoutData,
}) => {
    const { isLoading } = checkoutData;
    const realizationDate = checkoutValues.realizationDate || '';
    const realizationDates = checkoutData.data?.realizationDates || [];

    useEffect(() => {
        fetchCheckoutData(`grant/checkout/${cartToken}/realization-date`);
    }, []);

    const renderOption = ({
        code,
        endAt,
        startAt,
    }: {
        code: string;
        endAt: string;
        startAt: string;
    }) => {
        return (
            <MenuItem key={code} value={code}>
                {formatDateToPolish(startAt)} – {formatDateToPolish(endAt)}
            </MenuItem>
        );
    };

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Grid item xs={12} md={5} lg={4}>
                <Box alignItems="center" display="flex">
                    <FormControl variant="outlined" fullWidth>
                        <Controller
                            as={<Select>{realizationDates.map(renderOption)}</Select>}
                            control={control}
                            displayEmpty
                            input={<OutlinedInput />}
                            name={REALIZATION_DATE}
                            disabled={isLoading}
                            defaultValue={realizationDate}
                            value={realizationDate}
                            variant="outlined"
                        />
                    </FormControl>
                </Box>
                <ErrorPanel errors={errors} name={REALIZATION_DATE} />
            </Grid>
        </Grid>
    );
};

export default RealizationDate;
